<div
    class="container-fluid well"
    data-test-automation="strata-schema-details">
    <h5>{{title}}</h5>

    @if (displaySchemeName() || getModel().planPurpose?.schemeTiers) {
        <div class="row">
            @if (displaySchemeName()) {
                <div class="col-xs-6">
                    <label class="control-label required-input">Scheme name</label>
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div
                            class="input-group"
                            [ngClass]="{'has-error':strataNameInput.invalid && strataNameInput.dirty}">
                            <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                            <input
                                type="text"
                                class="form-control"
                                [name]="'strataName'"
                                #strataNameInput="ngModel"
                                [disabled]="!isStrataNameEnabled() || readonly ||  (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                [id]="'strataName'"
                                required
                                placeholder="Enter strata name"
                                maxlength="120"
                                [(ngModel)]="strataNameValue"
                                title="Enter the scheme name. It must be unique."
                                data-test-automation="strata-name" />
                        </div>
                    }
                </div>
            }
            <!-- Scheme Tiers -->
            @if (getModel().planPurpose?.schemeTiers) {
                <div class="col-xs-6">
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div>
                            <label class="control-label required-input">Scheme tiers</label>
                            <div class="input-group">
                                @for (option of schemeTierValues; track option; let i = $index) {
                                    <label class="nlr-radio">
                                        <input
                                            type="radio"
                                            [ngClass]="{'has-radio-error':roadClosureInput.invalid && roadClosureInput.dirty}"
                                            #roadClosureInput="ngModel"
                                            [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                            [name]="'schemeTier'+i"
                                            [id]="'schemeTier'+i"
                                            [value]="option.id"
                                            [(ngModel)]="getStrata().schemeTiers"
                                            required
                                            data-test-automation="laa-acquisition-option-{{option.id}}" />
                                        <span>{{option.displayValue}}</span>
                                    </label>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }

    <div class="row">
        <div class="col-xs-12">
            <label class="control-label">Parcel address</label>
        </div>
        <div class="col-xs-12">
            <label class="control-label">Address 1</label>
        </div>

        <div class="col-xs-3">
            <label class="control-label required-input">Road number</label>
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div
                    class="input-group"
                    [ngClass]="{'has-error': roadNumberOneInput.invalid && roadNumberOneInput.dirty}">
                    <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                    <input
                        type="text"
                        class="form-control"
                        [name]="'roadNumberOne'"
                        #roadNumberOneInput="ngModel"
                        [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                        [id]="'roadNumberOne'"
                        placeholder="Enter road number"
                        [(ngModel)]="getStrata().parcelAddressRoadNumber"
                        maxlength="10"
                        required
                        data-test-automation="road-number-1" />
                </div>
            }
        </div>

        <div class="col-xs-3">
            <label class="control-label required-input">Road name</label>
            @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
                <div>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': roadNameOneInput.invalid && roadNameOneInput.dirty}">
                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                        <input
                            type="text"
                            [id]="'roadNameOne'"
                            [name]="'roadNameOne'"
                            class="form-control"
                            [(ngModel)]="getParcelAddressRoadName().displayName"
                            placeholder="Search road"
                            #roadNameOneInput="ngModel"
                            [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                            required
                            autocomplete="off"
                            (ngModelChange)="roadOneChanged($event)"
                            (itemSelected)="roadOneSelected($event)"
                            [nlrTypehead]="roadsSearch"
                            maxlength="35"
                            data-test-automation="road-name-1" />
                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-search"></i></span>
                    </div>
                    @if (!isRoadOneValid() && roadNameOneInput.dirty) {
                        <div
                            class="help-block"
                            data-test-automation="error-road-name-1">
                            <span>Error!</span>
                            <span>No road name found.</span>
                        </div>
                    }
                </div>
            }
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12">
            <label class="control-label">Address 2</label>
        </div>
        <div class="col-xs-3">
            <label class="control-label">Road number</label>
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div
                    class="input-group"
                    [ngClass]="{'has-error': roadNumberTwoInput.invalid && roadNumberTwoInput.dirty}">
                    <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                    <input
                        type="text"
                        class="form-control"
                        [name]="'roadNumberTwo'"
                        #roadNumberTwoInput="ngModel"
                        [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                        [id]="'roadNumberTwo'"
                        placeholder="Enter road number"
                        [(ngModel)]="getStrata().parcelAddressRoadNumber2"
                        maxlength="10"
                        data-test-automation="road-number-1" />
                </div>
            }
        </div>
        <div class="col-xs-3">
            <label class="control-label">Road name</label>
            @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
                <div>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': roadNameTwoInput.invalid && roadNameTwoInput.dirty}">
                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                        <input
                            type="text"
                            [id]="'roadNameTwo'"
                            [name]="'roadNameTwo'"
                            class="form-control"
                            [(ngModel)]="getParcelAddressRoadName2().displayName"
                            placeholder="Search road"
                            #roadNameTwoInput="ngModel"
                            [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                            autocomplete="off"
                            (ngModelChange)="roadTwoChanged($event)"
                            (itemSelected)="roadTwoSelected($event)"
                            [nlrTypehead]="roadsSearch"
                            maxlength="35"
                            data-test-automation="road-name-1" />
                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-search"></i></span>
                    </div>
                    @if (roadNameTwoInput.invalid && !isRoadTwoSelected &&roadNameTwoInput.dirty) {
                        <div
                            class="help-block"
                            data-test-automation="error-road-name-1">
                            <span>Error!</span>
                            <span>No road name found.</span>
                        </div>
                    }
                </div>
            }
        </div>
    </div>

    <div class="row">
        <div class="col-xs-3">
            <label class="control-label">Locality</label>
            <div class="input-group">
                @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
                    <input
                        type="text"
                        class="form-control"
                        [name]="'locality'"
                        [id]="'locality'"
                        placeholder="Enter locality"
                        [(ngModel)]="getStrata().locality"
                        readonly
                        data-test-automation="locality" />
                }
            </div>
        </div>

        @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
            <div class="col-xs-3">
                <label class="control-label">Local government authority</label>
                <div class="input-group">
                    <input
                        type="text"
                        class="form-control"
                        [name]="'lga'"
                        [id]="'lga'"
                        placeholder="Enter local government authority"
                        [(ngModel)]="getStrata().lga"
                        readonly
                        data-test-automation="lga" />
                </div>
            </div>
        }
    </div>

    @if (displaySchemeVacantLot()) {
        <div class="row">
            <div class="col-xs-6">
                <label class="control-label required-input">Does plan create a vacant strata lot?</label>
                <div class="input-group">
                    @for (option of vacantStrataLotValues; track option; let i = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error': vacantStrataLotInput.invalid && vacantStrataLotInput.dirty}"
                                    #vacantStrataLotInput="ngModel"
                                    [name]="'vacantStrataLot'+i"
                                    [id]="'vacantStrataLot'+i"
                                    [value]="option.id"
                                    [(ngModel)]="getStrata().createsVacantStrataLot"
                                    [disabled]="!option.active || readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    required
                                    data-test-automation="laa-acquisition-option-{{option.id}}" />
                            }
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
    }
    @if (getModel().planPurpose?.zaDocument) {
        <div class="row">
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div class="col-xs-6">
                    <label class="control-label"> Notice of resolution merger document number (ZA) </label>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': mergerDocumentNumberInput | formFieldHasError}">
                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                        <input
                            type="text"
                            class="form-control"
                            [name]="'mergerDocumentNumber'"
                            [id]="'mergerDocumentNumber'"
                            #mergerDocumentNumberInput="ngModel"
                            [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                            min="0"
                            maxlength-input-limit="12"
                            placeholder="Enter merger document number"
                            [nlrPattern]="documentPattern"
                            [(ngModel)]="getStrata().mergerDocumentNumber"
                            title="Enter the notice of resolution document number for a strata plan merger" />
                    </div>
                    @if (mergerDocumentNumberInput | formFieldHasError) {
                        <div class="help-block">
                            <span>Error!</span>
                            <span>Incorrect entry, format should be document prefix and number e.g. M123456, T8606/1961</span>
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (getModel().planPurpose?.zbDocument) {
        <div class="row">
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div class="col-xs-6">
                    <label class="control-label"> Notice of resolution conversion document number (ZB) </label>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': conversionDocumentNumberInput | formFieldHasError}">
                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                        <input
                            type="text"
                            class="form-control"
                            [name]="'conversionDocumentNumber'"
                            [id]="'conversionDocumentNumber'"
                            #conversionDocumentNumberInput="ngModel"
                            min="0"
                            [maxLengthInputLimit]="8"
                            placeholder="Enter conversion document number"
                            [(ngModel)]="getStrata().conversionDocumentNumber"
                            [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                            [nlrPattern]="documentPattern"
                            title="Enter the notice of resolution document number for a survey-strata conversion" />
                        @if (conversionDocumentNumberInput | formFieldHasError) {
                            <div class="help-block">
                                <span>Error!</span>
                                <span>Incorrect entry, format should be document prefix and number e.g. M123456, T8606/1961</span>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }

    @if (getModel().planPurpose?.mergerPerScheme) {
        <div class="row">
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div class="col-xs-12">
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': priorMergerApprovedInput.invalid && priorMergerApprovedInput.dirty}">
                        <div
                            class="checkbox mg0"
                            title="Select if a merger has never been previously approved for this strata plan">
                            <div class="checkbox-inline">
                                @if (getStrata().priorMergerApproved) {
                                    <i
                                        class="active nlrp-icon nlrp-icon-check-box-selected"
                                        (click)="!readonly && (getStrata().priorMergerApproved = !getStrata().priorMergerApproved)"
                                        data-test-automation="prior-merger-approved"></i>
                                }
                                @if (!getStrata().priorMergerApproved  && !priorMergerApprovedInput.dirty) {
                                    <i
                                        class="nlrp-icon nlrp-icon-check-box-unselected"
                                        (click)="!readonly && (getStrata().priorMergerApproved = !getStrata().priorMergerApproved)"
                                        data-test-automation="prior-merger-approved"></i>
                                }
                                @if (priorMergerApprovedInput.invalid && priorMergerApprovedInput.dirty) {
                                    <i
                                        class="nlrp-icon nlrp-icon-check-box-unselected nlrp-icon-check-box-unselected-error"
                                        (click)="!readonly && (getStrata().priorMergerApproved = !getStrata().priorMergerApproved)"
                                        data-test-automation="prior-merger-approved"></i>
                                }
                                <span class="required-input"
                                    >I confirm that a prior merger strata plan has never been approved for this strata scheme</span
                                >
                                <input
                                    type="checkbox"
                                    [name]="'priorMergerApproved'"
                                    [id]="'priorMergerApproved'"
                                    #priorMergerApprovedInput="ngModel"
                                    id="priorMergerApproved"
                                    [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    [(ngModel)]="getStrata().priorMergerApproved"
                                    required
                                    style="visibility: hidden;" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }

    @if (displayManagementStatement()) {
        <div class="row">
            <div class="col-xs-12">
                <label class="control-label required-input">I confirm that scheme by-laws exist or will be lodged</label>
                <div class="input-group">
                    @for (option of managementStatementExists; track option; let i = $index) {
                        <label class="nlr-radio">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error':managementStatementExistsInput.invalid && managementStatementExistsInput.dirty}"
                                    #managementStatementExistsInput="ngModel"
                                    [name]="'managementStatementExists'+i"
                                    [id]="'managementStatementExists'+i"
                                    [value]="option.id"
                                    [disabled]="!option.active || readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    [(ngModel)]="getStrata().managementStatementExists"
                                    required
                                    data-test-automation="management-statement-exists-option" />
                            }
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
    }
</div>
<!--<div class="help-block">-->
<!--    <span>Error!</span>-->
<!--    <span>{{groups.planInformation.invalidStrataSchemaDetailsText}}</span>-->
<!--</div>-->
